// module_configs/cosmetics.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faWandMagicSparkles, faUsersCog,
  faBuildingColumns
} from '@fortawesome/free-solid-svg-icons';

// Import Cosmetics components
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';

import DashboardHomeUser from '.././module_cosmetics/cosmetics_Userhomedash';

import AddCustomer from '.././module_mechanics/mechanics_customer';

import CustomerList from '.././module_mechanics/mechanics_customer_list';

import AddSupplier from '.././module_mechanics/mechanics_Supplier';

import SupplierList from '.././module_mechanics/mechanics_SuppliersList';

import AddEmployee from '.././module_mechanics/mechanics_employees';

import MecEmployeeList from '.././module_mechanics/mechanic_employeelist';

import CosmeticsProducts from '.././module_cosmetics/cosmetics_products';

import CosmeticsProductsList from '.././module_cosmetics/cosmetics_productslist';

import CosmeticsPurchases from '.././module_cosmetics/cosmetics_Purchases';

import CosmeticsPurchaseList from '.././module_cosmetics/cosmetics_PurchaseList';

import CosmeticsReturn from '.././module_cosmetics/cosmetics_Return';

import CosmeticsReturnList from '.././module_cosmetics/cosmetics_Returnlist';

import CosmeticsSell from '.././module_cosmetics/cosmetics_Sell';

import CosmeticsSalesList from '.././module_cosmetics/cosmetics_SellList';

import CosmeticsSalesInvoicesList from '.././module_cosmetics/cosmetics_SellInvoiceList';

import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

import AddTransactionForm from '.././module_cosmetics/cosmetics_addtransactions';

import CosmeticsTransactions from '../module_cosmetics/cosmetics_transactions';

import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';

import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';
import CosmeticsPurchaseReturn from '../module_cosmetics/cosmetics_purchasereturn';
import CosmeticsPurchaseReturnList from '../module_cosmetics/cosmetics_PurchaseReturnlist';
import MechanicsAccounts from '../module_cosmetics/cosmetics_Accounts';
import MechanicsCashLedger from '../module_cosmetics/cosmetics_CashLedger';
import CosmeticsTransactionsManagerSpecial from '../module_cosmetics/cosmetics_transactions copy';

export const cosmeticsConfig = {
  moduleId: 'cosmetics',
  moduleName: 'Cosmetics & Beauty',
  icon: faWandMagicSparkles,
  description: 'Cosmetics & Beauty Shop Management System',
  i18n: {
    defaultLanguage: 'en',
    supportedLanguages: ['en', 'ur', 'ps', 'ar', 'tr', 'fa', 'prs'],
    rtlLanguages: ['ur', 'ps', 'ar', 'fa', 'prs']
  },
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_cosmetics': { level: 1, label: 'Admin', color: '#ec4899' },
    'manager_cosmetics': { level: 2, label: 'Manager', color: '#f43f5e' },
    'user_cosmetics': { level: 3, label: 'User', color: '#be185d' },
    'viewer_cosmetics': { level: 4, label: 'Viewer', color: '#db2777' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'sales', name: 'Sales & Sales Returns', icon: faCartShopping, order: 2 },
    { id: 'inventory', name: 'Stock & Inventory', icon: faBoxes, order: 3 },
    { id: 'accounts', name: 'Accounts & Transactions', icon: faBuildingColumns, order: 4 },
    { id: 'billing', name: 'Billing & Renewals', icon: faFileInvoice, order: 5 },
    { id: 'settings', name: 'Settings', icon: faCog, order: 6 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomerList,
          icon: faUsersLine,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserTie,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faBuildingUser,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MecEmployeeList,
          icon: faIdCard,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock',
      icon: faCubes,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: CosmeticsProducts,
          icon: faCube,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: CosmeticsProductsList,
          icon: faListAlt,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'inventory',
      position: 5,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: CosmeticsPurchases,
          icon: faCartPlus,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: CosmeticsPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: CosmeticsSupplierPurchases,
          icon: faBuilding,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: CosmeticsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'purchasereturns',
      label: 'Purchase Returns',
      aliases: ['purchase_return', 'purchasereturn', 'purchase_returns'],
      icon: faArrowRotateLeft,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addpurchasereturn',
          label: 'New Purchase Return',
          aliases: ['add_purchase_return', 'new_purchase_return', 'purchasereturn'],
          component: CosmeticsPurchaseReturn,
          icon: faRotateLeft,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'purchasereturnlist',
          label: 'Purchase Return List',
          aliases: ['purchase_return_list', 'purchasereturnlist'],
          component: CosmeticsPurchaseReturnList,
          icon: faListCheck,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'sales',
      position: 0,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: CosmeticsSell,
          icon: faCartPlus,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: CosmeticsSalesList,
          icon: faClipboardList,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'salesproductswise',
          label: 'Product-wise',
          component: CosmeticsSalesInvoicesList,
          icon: faClipboardList,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Sales Returns',
      aliases: ['sale_return', 'sales_return', 'salereturn', 'salesreturns', 'solar_return'],
      icon: faArrowRotateLeft,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'sales',
      position: 1,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Sales Return',
          aliases: ['add_sale_return', 'new_sale_return', 'solar_return'],
          component: CosmeticsReturn,
          icon: faRotateLeft,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'returnlist',
          label: 'Sales Return List',
          aliases: ['sale_return_list', 'sales_return_list', 'solar_returnlist'],
          component: CosmeticsReturnList,
          icon: faListCheck,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
   {
            id: 'financials',  // or 'accounting'
            label: 'Financials',  // or 'Accounting'
            icon: faMoneyBillWave,
            roles: ['admin_cosmetics', 'manager_cosmetics'],
            groupId: 'accounts',
            position: 0,
            submenus: [
              {
                id: 'newtransaction',
                label: 'New Transaction',
                component: AddTransactionForm,
                icon: faPlus,
                roles: ['admin_cosmetics', 'manager_cosmetics']
              },
              {
                id: 'alltransactions',
                label: 'All Transactions',
                component: CosmeticsTransactionsManagerSpecial,
                icon: faMoneyBillWave,
                roles: ['admin_cosmetics', 'manager_cosmetics']
              },
              {
                id: 'accounts',
                label: 'Accounts',
                component: MechanicsAccounts,
                icon: faBuildingColumns, // or faUniversity
                roles: ['admin_cosmetics', 'manager_cosmetics']
              },
              {
                id: 'cashledger',
                label: 'Cash & Bank Ledger',
                component: MechanicsCashLedger,
                icon: faMoneyBillWave,
                roles: ['admin_cosmetics', 'manager_cosmetics']
              }
            ]
          },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'inventory',
      position: 10,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: MechanicsBarcode,
          icon: faPrint,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'billing',
      label: 'Billing & Renewals',
      aliases: ['billing', 'renewals', 'billing_renewals'],
      icon: faFileInvoice,
      roles: ['admin_cosmetics', 'manager_cosmetics'],
      groupId: 'billing',
      position: 0,
      submenus: [
        { id: 'generatebill', label: 'Generate Bill', component: null, icon: faPlus, roles: ['admin_cosmetics', 'manager_cosmetics'] },
        { id: 'billinghistory', label: 'Billing History', component: null, icon: faReceipt, roles: ['admin_cosmetics', 'manager_cosmetics'] },
        { id: 'renewals', label: 'Renewals', component: null, icon: faArrowRotateLeft, roles: ['admin_cosmetics', 'manager_cosmetics'] }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_cosmetics'],
      groupId: 'settings',
      position: 0,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'settings',
      position: 1,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$1,245' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 156 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 89 },
    { id: 'pending', label: 'Pending Orders', icon: 'faClock', value: 7 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard', menuId: 'dashboard' },
    { key: 'Alt + C', description: 'Customers', menuId: 'customers' },
    { key: 'Alt + Shift + A', description: 'Add Customer', menuId: 'customers', submenuId: 'addcustomer' },
    { key: 'Alt + Shift + B', description: 'Customer List', menuId: 'customers', submenuId: 'customerlist' },
    { key: 'Alt + S', description: 'Suppliers', menuId: 'suppliers' },
    { key: 'Alt + Shift + C', description: 'Add Supplier', menuId: 'suppliers', submenuId: 'addsupplier' },
    { key: 'Alt + Shift + D', description: 'Supplier List', menuId: 'suppliers', submenuId: 'supplierlist' },
    { key: 'Alt + E', description: 'Employees', menuId: 'employees' },
    { key: 'Alt + Shift + E', description: 'Add Employee', menuId: 'employees', submenuId: 'addemployees' },
    { key: 'Alt + Shift + F', description: 'Employees List', menuId: 'employees', submenuId: 'employeeslist' },
    { key: 'Alt + A', description: 'Sales', menuId: 'sales' },
    { key: 'Alt + Shift + G', description: 'New Sale', menuId: 'sales', submenuId: 'addsale' },
    { key: 'Alt + Shift + H', description: 'Sales List', menuId: 'sales', submenuId: 'saleslist' },
    { key: 'Alt + Shift + I', description: 'Product-wise Sales', menuId: 'sales', submenuId: 'salesproductswise' },
    { key: 'Alt + R', description: 'Sales Returns', menuId: 'returns' },
    { key: 'Alt + Shift + J', description: 'New Sales Return', menuId: 'returns', submenuId: 'addreturn' },
    { key: 'Alt + Shift + K', description: 'Sales Return List', menuId: 'returns', submenuId: 'returnlist' },
    { key: 'Alt + K', description: 'Stock', menuId: 'stock' },
    { key: 'Alt + Shift + L', description: 'Add Stock', menuId: 'stock', submenuId: 'addstock' },
    { key: 'Alt + Shift + M', description: 'Stock List', menuId: 'stock', submenuId: 'stocklist' },
    { key: 'Alt + U', description: 'Purchases', menuId: 'purchases' },
    { key: 'Alt + Shift + N', description: 'New Purchase', menuId: 'purchases', submenuId: 'addpurchase' },
    { key: 'Alt + Shift + O', description: 'Purchases List', menuId: 'purchases', submenuId: 'purchaselist' },
    { key: 'Alt + Shift + P', description: 'Supplier-wise Purchases', menuId: 'purchases', submenuId: 'purchasessupplierwise' },
    { key: 'Alt + Shift + Q', description: 'Bill-wise Purchases', menuId: 'purchases', submenuId: 'purchasesinvoicewise' },
    { key: 'Alt + T', description: 'Purchase Returns', menuId: 'purchasereturns' },
    { key: 'Alt + Shift + R', description: 'New Purchase Return', menuId: 'purchasereturns', submenuId: 'addpurchasereturn' },
    { key: 'Alt + Shift + S', description: 'Purchase Return List', menuId: 'purchasereturns', submenuId: 'purchasereturnlist' },
    { key: 'Alt + B', description: 'Barcodes', menuId: 'barcode' },
    { key: 'Alt + Shift + T', description: 'Barcode Printing', menuId: 'barcode', submenuId: 'barcodeprinting' },
    { key: 'Alt + F', description: 'Financials', menuId: 'financials' },
    { key: 'Alt + Shift + U', description: 'New Transaction', menuId: 'financials', submenuId: 'newtransaction' },
    { key: 'Alt + Shift + V', description: 'All Transactions', menuId: 'financials', submenuId: 'alltransactions' },
    { key: 'Alt + Shift + W', description: 'Accounts', menuId: 'financials', submenuId: 'accounts' },
    { key: 'Alt + Shift + X', description: 'Cash & Bank Ledger', menuId: 'financials', submenuId: 'cashledger' },
    { key: 'Alt + L', description: 'Billing & Renewals', menuId: 'billing' },
    { key: 'Alt + Shift + Y', description: 'Generate Bill', menuId: 'billing', submenuId: 'generatebill' },
    { key: 'Alt + Shift + Z', description: 'Billing History', menuId: 'billing', submenuId: 'billinghistory' },
    { key: 'Alt + Shift + 0', description: 'Renewals', menuId: 'billing', submenuId: 'renewals' },
    { key: 'Alt + O', description: 'Settings', menuId: 'settings' },
    { key: 'Alt + V', description: 'Notifications Center', menuId: 'systemupdates' },
    { key: 'Escape', description: 'Hide or show sidebar', action: 'toggleSidebar' },
    { key: 'Alt + J', description: 'Open or close shop switcher', action: 'toggleShopSwitcher' },
    { key: 'Alt + M', description: 'Change to next theme color', action: 'cycleTheme' },
    { key: 'Alt + X', description: 'Switch dark or light mode', action: 'toggleDarkMode' },
    { key: 'Alt + Q', description: 'Focus menu search', action: 'focusSearch' },
    { key: 'Alt + Y', description: 'Change to next language', action: 'cycleLanguage' },
    { key: 'Alt + H', description: 'Show or hide keyboard shortcuts', action: 'toggleShortcuts' }
  ]
};
